import { 
    LOAD_COMPANIES_FOR_ITEMS, 
    SET_COMPANIES_FOR_ITEMS 
} from "redux/reducers/companies/companiesForItemsReducer"
import { api_get, PROYECT } from '../../../services/api'


export const getCompaniesForItems = (token) => {
    const auth = { headers: { authorization: `${token}` } };
    const url = `${process.env.REACT_APP_URL}${PROYECT}/companies-for-items`;
    return async (dispatch) => {
        dispatch({ type: LOAD_COMPANIES_FOR_ITEMS })
        await api_get(url, auth).then(resp => {
            dispatch({
                type: SET_COMPANIES_FOR_ITEMS,
                payload: resp.companies
            })
        })
    }
}
